import { StyleSheet } from 'react-native'

import { colors as zetColors } from '@zet/design-system'
import { Icon } from '@zet/design-system/index'
import { Stack } from '@zet/design-system/layout'
import { B1, B2, B5 } from '@zet/design-system/typography'
import { WebDatePicker } from '@zet/design-system/webDatePicker'
import moment from 'moment'

const computeDate = (date?: string, durationInYears?: number) => {
  if (date) {
    if (date === 'CURRENT_DATE') {
      return moment().format('YYYY-MM-DD')
    }
    return moment(date).format('YYYY-MM-DD')
  } else if (durationInYears) {
    if (durationInYears < 0) {
      return moment()
        .subtract(Math.abs(durationInYears), 'years')
        .format('YYYY-MM-DD')
    } else {
      return moment().add(durationInYears, 'years').format('YYYY-MM-DD')
    }
  }
}

interface Props {
  label: string
  onChange: (date: string) => void
  onBlur: () => void
  value: string
  errors: any
  isRequired?: boolean
  disabled?: boolean
  config?: {
    minDateDuration?: number // In years
    maxDateDuration?: number // In years
    minDate?: string
    maxDate?: string
    required?: boolean
  }
  errorMessage: string
}

const DateSelector = ({
  label,
  onChange,
  onBlur,
  value,
  errors,
  isRequired = true,
  config,
  errorMessage,
  disabled,
}: Props) => {
  const minDate = computeDate(config?.minDate, config?.minDateDuration)
  const maxDate = computeDate(config?.maxDate, config?.maxDateDuration)

  return (
    <Stack className="mt-1">
      <B2 className="text-grays-80 mb-1">
        {label}
        {isRequired ? <B1 className="text-error-100 ml-1">*</B1> : <></>}
      </B2>
      <Stack className={`justify-center ${disabled ? 'bg-grays-30' : ''}`}>
        <Icon
          type="CalenderOutlined"
          color={zetColors.grays[50]}
          className="absolute ml-1.5"
          size={20}
          viewBox={'0 0 20 20'}
        ></Icon>
        <WebDatePicker
          onChange={(v) => {
            onChange(v?.target?.value)
          }}
          onBlur={onBlur}
          disabled={disabled}
          value={value ? value : ''}
          minDate={minDate ?? null}
          maxDate={maxDate ?? null}
          style={{
            ...styles.datePicker,
            borderColor: errorMessage ? 'red' : '#d1d9e9',
          }}
        />
        {errorMessage && (
          <Stack className="absolute right-1">
            <Icon color={zetColors.error[100]} type="ErrorOutlined" size={28} />
          </Stack>
        )}
      </Stack>
      {errors?.name?.message || errorMessage ? (
        <Stack className="mt-2">
          <B5 className="text-error-100">
            {errors?.name?.message || errorMessage}
          </B5>
        </Stack>
      ) : null}
    </Stack>
  )
}

const styles = StyleSheet.create({
  datePicker: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    fontFamily: 'Graphie-Book',
    paddingTop: 12,
  },
})
export default DateSelector
